import App from './app';

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js